import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ComponentEmptyButton } from '../shared/component-parts';
import LinkView from './link-view';
import { EditProps } from './link.constants';

const LinkEdit = (props: EditProps) => {
  const { openDrawer } = useActivityBuilderContext();

  return props.stimulusResourceProperties ? (
    <LinkView {...props} />
  ) : (
    <ComponentEmptyButton
      iconId="link"
      onClick={() => openDrawer({ componentId: props.id })}
      buttonText="Add Link"
      isSmall
    />
  );
};

export default LinkEdit;
